import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeMusicToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeMusicToTidal}
            sections={<PairSyncGuideContent sourceKey="youtubeMusic" destKey="tidal" />}
        />
    );
}
